module.exports = __webpack_public_path__ + "img/hz3.1d4cbfd7.png";